import { getCookieValue } from './getCookieValue';
import { COOKIE_KEYS } from './constants';
import { Cookie } from './types';

export const getDeviceId = (cookie: Cookie): string | null =>
    getCookieValue(cookie, COOKIE_KEYS.DEVICE_ID);
